export enum AnalyticsSubsection {
  HOME_PAGE = 'home_page',
  CONFERMA_DATI = 'conferma_dati',
  ERROR_PAGE = 'error_page',
  QUOTAZIONE = 'quotazione',
  SALVA_ACQUISTA = 'salva_acquista',
  THANKYOU_PAGE = 'thankyou_page',
  RECUPERO_PREVENTIVO = 'recupero_preventivo',
  RECUPERO_PREVENTIVO_ALLIANZ_PAY = 'recupero_preventivo_allianz_pay',
  RIEPILOGO_ALLIANZ_PAY = 'riepilogo_allianz_pay',
  PURCHASE_ALLIANZ_PAY = 'purchase_allianz_pay',
  NOT_FOUND = '404',
  DISSERVIZIO = 'disservizio',
}
